module.exports = __webpack_public_path__ + "static/img/nodata.7888712.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/nodata.png
// module id = Pq3K
// module chunks = 1